import React, { useEffect } from "react";

export interface GenericModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: React.ReactNode;
    children: React.ReactNode;
    size?: "sm" | "md" | "lg" | string;
    closeOnBackdropClick?: boolean;
    blurBackdrop?: boolean;
    maxHeight?: string;
    overflowY?: "auto" | "visible" | "hidden";
}

const GenericModal: React.FC<GenericModalProps> = ({
    isOpen,
    onClose,
    title,
    children,
    size = "lg",
    closeOnBackdropClick = true,
    blurBackdrop = false,
    maxHeight,
    overflowY = "visible",
}) => {
    if (!isOpen) return null;

    let modalWidthClass = "w-full max-w-md";
    if (size === "sm") {
        modalWidthClass = "w-full max-w-sm";
    } else if (size === "md") {
        modalWidthClass = "w-full max-w-md";
    } else if (size === "lg") {
        modalWidthClass = "w-full max-w-3xl";
    } else {
        modalWidthClass = `w-full ${size}`;
    }

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center px-4 py-6"
            aria-modal="true"
            role="dialog"
        >
            <div
                role="button"
                aria-label="Close modal backdrop"
                onClick={() => {
                    if (closeOnBackdropClick) onClose();
                }}
                className={
                    // base backdrop
                    "absolute inset-0 bg-black bg-opacity-30" +
                    // conditional blur
                    (blurBackdrop ? " backdrop-blur-sm" : "")
                  }
            />
            <div
                className={`
                relative z-10
                bg-[var(--color-semantic-bg-primary)]
                rounded-sm
                border
                border-[var(--color-semantic-border-secondary)]
                shadow-lg
                p-4
                ${maxHeight ? `overflow-y-${overflowY}` : ''}
                ${modalWidthClass}
                `}
                style={maxHeight ? { maxHeight, overflowY } : undefined}
            >
                <div className="relative mb-4 py-2">
                    {title && (
                        <h2 className="text-lg font-semibold text-[var(--color-semantic-text-secondary)]">
                            {title}
                        </h2>
                    )}
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="Close modal"
                        className="
              absolute
              top-[-0.5rem]
              right-0
              text-3xl
              text-[var(--color-semantic-text-secondary)]
              hover:text-[var(--color-semantic-text-primary)]
              focus:outline-none
            "
                    >
                        &times;
                    </button>
                </div>

                <div className="
            semantic text‐primary
            text-[var(--color-semantic-text-primary)]">{children}</div>
            </div>
        </div>
    );
};

export default GenericModal;
